module.exports = __webpack_public_path__ + "img/7b4f1406ba03f82b2e5157b0e9367544.png";